var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHypothyroidism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20.66367 19.915094",
    id: "svg46",
    width: 21,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs14"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "\n      .hypothyroidism-cls-1 {\n        clip-path: url(#clippath-6);\n      }\n\n      .hypothyroidism-cls-2 {\n        clip-path: url(#clippath-7);\n      }\n\n      .hypothyroidism-cls-3 {\n        clip-path: url(#clippath-4);\n      }\n\n      .hypothyroidism-cls-4 {\n        clip-path: url(#clippath-9);\n      }\n\n      .hypothyroidism-cls-5 {\n        clip-path: url(#clippath-10);\n      }\n\n      .hypothyroidism-cls-6 {\n        clip-path: url(#clippath-11);\n      }\n\n      .hypothyroidism-cls-7, .hypothyroidism-cls-8 {\n        fill: none;\n      }\n\n      .hypothyroidism-cls-9 {\n        clip-path: url(#clippath-1);\n      }\n\n      .hypothyroidism-cls-10 {\n        clip-path: url(#clippath-5);\n      }\n\n      .hypothyroidism-cls-11 {\n        clip-path: url(#clippath-8);\n      }\n\n      .hypothyroidism-cls-12 {\n        clip-path: url(#clippath-3);\n      }\n\n      .hypothyroidism-cls-13 {\n        clip-path: url(#clippath-12);\n      }\n\n      .hypothyroidism-cls-8 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n\n      .hypothyroidism-cls-14 {\n        clip-path: url(#clippath-2);\n      }\n\n      .hypothyroidism-cls-15 {\n        clip-path: url(#clippath-13);\n      }\n\n      .hypothyroidism-cls-16 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "hypothyroidism-cls-7",
    x: 3.6700001,
    y: 4.04,
    width: 9.8999996,
    height: 19.92,
    id: "rect1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "hypothyroidism-cls-7",
    x: 13.57,
    y: 4.04,
    width: 9.8999996,
    height: 19.92,
    id: "rect2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "hypothyroidism-cls-7",
    x: 3.1099999,
    y: 10.62,
    width: 7.1199999,
    height: 11.89,
    id: "rect3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "hypothyroidism-cls-7",
    x: 16.66,
    y: 10.62,
    width: 7.1199999,
    height: 11.89,
    id: "rect4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "hypothyroidism-cls-7",
    x: 6.3800001,
    y: 13.43,
    width: 5.3899999,
    height: 6.1900001,
    id: "rect5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "hypothyroidism-cls-7",
    x: 15.39,
    y: 13.43,
    width: 5.3899999,
    height: 6.1900001,
    id: "rect6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g46",
    transform: "translate(-3.1131649,-4.0449046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hypothyroidism-cls-16",
    clipPath: "url(#clippath)",
    id: "g15"
  }, /*#__PURE__*/React.createElement("line", {
    className: "hypothyroidism-cls-8",
    x1: 9.8800001,
    y1: 23.15,
    x2: 13.56,
    y2: 23.209999,
    id: "line14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hypothyroidism-cls-8",
    d: "m 9.34,18.69 c 0.47,2.35 0.43,4.4 0.43,4.4",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hypothyroidism-cls-8",
    d: "M 14.46,8.29 C 13.58,8.72 12.86,8.37 12.65,8.24 11.83,7.72 11.75,6.96 11.27,6.11 v 0 C 10.63,4.97 9.24,4.49 8.03,4.99 v 0 c -2.4,1 -5.09,5.25 -2.66,6.16 1.41,0.53 2.36,1.83 3.01,3.38",
    id: "path15"
  })), /*#__PURE__*/React.createElement("g", {
    className: "hypothyroidism-cls-9",
    clipPath: "url(#clippath-1)",
    id: "g17"
  }, /*#__PURE__*/React.createElement("line", {
    className: "hypothyroidism-cls-8",
    x1: 17.27,
    y1: 23.15,
    x2: 13.59,
    y2: 23.209999,
    id: "line15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hypothyroidism-cls-8",
    d: "m 17.81,18.69 c -0.47,2.35 -0.43,4.4 -0.43,4.4",
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hypothyroidism-cls-8",
    d: "m 12.69,8.29 c 0.88,0.43 1.6,0.08 1.81,-0.05 0.82,-0.52 0.9,-1.28 1.38,-2.13 v 0 c 0.64,-1.14 2.03,-1.62 3.24,-1.12 v 0 c 2.4,1 5.09,5.25 2.66,6.16 -1.41,0.53 -2.36,1.83 -3.01,3.38",
    id: "path17"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hypothyroidism-cls-14",
    clipPath: "url(#clippath-2)",
    id: "g19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hypothyroidism-cls-8",
    d: "M 5.21,11.37 4.95,11.7 C 4.38,12.42 4.14,13.37 4.3,14.29 l 0.16,0.93 -0.25,0.51 c -0.68,1.37 -0.33,3.05 0.82,4.02 l 0.2,0.17 0.56,0.6 c 1.37,1.45 3.68,1.22 3.68,1.22",
    id: "path18"
  })), /*#__PURE__*/React.createElement("g", {
    className: "hypothyroidism-cls-12",
    clipPath: "url(#clippath-3)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hypothyroidism-cls-8",
    d: "m 21.68,11.37 0.26,0.33 c 0.57,0.72 0.81,1.67 0.65,2.59 l -0.16,0.93 0.25,0.51 c 0.68,1.37 0.33,3.05 -0.82,4.02 l -0.2,0.17 -0.56,0.6 c -1.37,1.45 -3.68,1.22 -3.68,1.22",
    id: "path19"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Mirror_Repeat_x3E_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hypothyroidism-cls-3",
    clipPath: "url(#clippath-4)",
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hypothyroidism-cls-8",
    d: "m 7.13,14.18 c 0.09,0.53 3.15,0.66 3.24,0.62",
    id: "path21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hypothyroidism-cls-8",
    d: "M 7.75,18.88 C 8.88,18.05 10.99,18.1 11.02,18.2",
    id: "path22"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "hypothyroidism-cls-10",
    clipPath: "url(#clippath-5)",
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hypothyroidism-cls-8",
    d: "m 20.02,14.18 c -0.09,0.53 -3.15,0.66 -3.24,0.62",
    id: "path23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hypothyroidism-cls-8",
    d: "M 19.4,18.88 C 18.27,18.05 16.16,18.1 16.13,18.2",
    id: "path24"
  }))))), /*#__PURE__*/React.createElement("polygon", {
    points: "12.35,8.85 12.35,15.92 11.32,15.92 13.57,19.74 15.82,15.92 14.8,15.92 14.8,8.85 ",
    id: "polygon26"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHypothyroidism);
export default __webpack_public_path__ + "static/media/Hypothyroidism.ff2c3eea949a83aedd360f44af26330c.svg";
export { ForwardRef as ReactComponent };